// src/components/firebase.js
import { initializeApp, getApps  } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  inMemoryPersistence,
  onIdTokenChanged,
 onAuthStateChanged,
} from 'firebase/auth';
import {
  getFirestore,
  enableMultiTabIndexedDbPersistence,
  enableIndexedDbPersistence,
} from "firebase/firestore";

import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
// const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ Firestore persistence (IndexedDB cache) — для “моментальности” ленты после F5
// Multi-tab: не падает, если у пользователя открыто несколько вкладок
if (typeof window !== "undefined") {
  // Сначала пробуем multi-tab (лучший UX)
  enableMultiTabIndexedDbPersistence(db).catch((err) => {
    // Если по какой-то причине multi-tab недоступен — пробуем обычный IndexedDB persist
    enableIndexedDbPersistence(db).catch((err2) => {
      console.warn("Firestore persistence disabled:", err2?.code || err2);
    });

    // Можно оставить лог — чтобы понимать почему не включилось
    console.warn("Firestore multi-tab persistence failed:", err?.code || err);
  });
}

export const storage = getStorage(app);


// ① ждём настройку persistance (indexedDB → localStorage → memory)
export const authReady = (async () => {
  try {
    await setPersistence(auth, indexedDBLocalPersistence);
  } catch {
    try {
      await setPersistence(auth, browserLocalPersistence);
    } catch {
      await setPersistence(auth, inMemoryPersistence);
    }
  }
})();


export const refreshClaimsNow = async () => {
  const u = auth.currentUser;
  if (u) { try { await u.getIdToken(true); } catch {} }
};

export const attachAuthAutoRefresh = () => {
  let lastForce = 0;
  const COOLDOWN = 5 * 60 * 1000; // 5 минут

  const forceRefresh = async () => {
    const u = auth.currentUser;
    if (!u) return;
    const now = Date.now();
    if (now - lastForce < COOLDOWN) return; // анти-спам
    lastForce = now;
    try { await u.getIdToken(true); } catch {}
  };

  // 1) один раз после логина — ок
  const unsubAuth = onAuthStateChanged(auth, async (u) => {
    if (u) await forceRefresh();
  });

  // 2) при изменении токена — НИКАКОГО force refresh!
  const unsubToken = onIdTokenChanged(auth, async (u) => {
    if (!u) return;
    // если хочешь — просто читаем claims (без true)
    try {
      
    } catch {}
  });

  // 3) при возврате вкладки/фокусе — можно force, но с cooldown
  const onResume = async () => { await forceRefresh(); };
  const onVisibility = () => { if (document.visibilityState === "visible") onResume(); };

  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("focus", onResume);

  // 4) периодически — тоже ок, но с cooldown
  const iv = setInterval(onResume, 30 * 60 * 1000);

  return () => {
    try { unsubAuth(); } catch {}
    try { unsubToken(); } catch {}
    document.removeEventListener("visibilitychange", onVisibility);
    window.removeEventListener("focus", onResume);
    clearInterval(iv);
  };
};

